import { SoftwareLabel } from './software-label';

export class SoftwareType extends SoftwareLabel {}
